module.exports = __webpack_public_path__ + "media/images/icons/SVG/041-41c4224995bda5f4f3d6a6078d52c553.svg";